import type {
  MeResponse,
  NeedsReauthResponse,
  PreferencesResponse,
  UpdatePreferencesRequest,
  UserPreferences,
} from '@noma-eco/platform/schema';

import { apiFetch } from './api-base.js';

/**
 * Returns the user's me-payload, OR a sentinel `{ needsReauth: true }` shape
 * when the backend's auth plugin just bootstrapped a personal organisation
 * for a brand-new user. The caller is expected to detect the sentinel and
 * trigger `AuthKit.switchToOrganization({ organizationId })` so the next
 * access token carries `org_id`. See plan §2.7.
 */
export async function getMe(): Promise<MeResponse | NeedsReauthResponse> {
  return apiFetch<MeResponse | NeedsReauthResponse>(`/api/v1/me`);
}

export function isNeedsReauthResponse(
  res: MeResponse | NeedsReauthResponse,
): res is NeedsReauthResponse {
  return 'needsReauth' in res && res.needsReauth === true;
}

export async function updatePreferences(
  patch: UpdatePreferencesRequest,
): Promise<UserPreferences> {
  const r = await apiFetch<PreferencesResponse>(`/api/v1/me/preferences`, {
    method: 'PATCH',
    body: patch,
  });
  return r.preferences;
}
